import { useGretaAIChatChatActions } from '../../useGretaAIChatChatActions'
import { useGretaAIChatDrafts } from '../../useGretaAIChatDrafts'

export function useGretaAIChatSessionChatActions({
  activeChatId,
  chatListLoader,
  forgetChat,
  setActiveChatId,
}) {
  const { discardChatDraft, discardDraftIfSubmitted, draft, setDraft } =
    useGretaAIChatDrafts(activeChatId)

  const {
    chatAction,
    closeChatAction,
    confirmDeleteChat,
    confirmRenameChat,
    openDeleteChat,
    openRenameChat,
  } = useGretaAIChatChatActions({
    activeChatId,
    chatListLoader,
    discardChatDraft,
    forgetChat,
    setActiveChatId,
  })

  return {
    chatAction,
    chatActions: {
      setDraft,
      onCloseChatAction: closeChatAction,
      onConfirmDeleteChat: confirmDeleteChat,
      onConfirmRenameChat: confirmRenameChat,
      onDeleteChat: openDeleteChat,
      onRenameChat: openRenameChat,
    },
    discardDraftIfSubmitted,
    draft,
  }
}
